import axios from 'axios'
import store from '../store'
import { common } from './common'
import { objectToFormdata } from './common'

function decodeIssuedToken(token) {
    let [header, payload, signature] = token.split('.')
    header = signature = payload = JSON.parse(atob(payload))
    return payload;
}

const https = axios.create({
    // baseURL: "https://pcsbo.peoplechains.io"
    baseURL: process.env.VUE_SYNC_API
});

https.defaults.crossDomain = true;

https.interceptors.request.use(
    config => {
        config["headers"] = {
            Accept: "application/json, text/plain, */*",
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

https.interceptors.response.use(
    response => {
        return response;
    },
    async function(error) {

        const originalRequest = error.config;

        if (error.response.status !== 401 && error.response.status !== 403) {
            return new Promise.reject(error)
        }
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            //request api common to refresh token
            const resToken = await common.get.autoRefreshToken({
                luidx: store.state.luidx
            })

            if (resToken.data.status === 200) {
                localStorage.setItem('accessToken', resToken.data.data.accessToken)
                
                let tokenInfo = decodeIssuedToken(resToken.data.data.accessToken)
                
                //An authentic token information is saved on vuex
                store.state.uuid = tokenInfo.sub
                store.state.luidx = Number(atob(tokenInfo.umc))
                store.state.cbidx = Number(atob(tokenInfo.cbc))
                store.state.accessToken = resToken.data.data.accessToken

                originalRequest.headers['Authorization'] = `Bearer ${resToken.data.data.accessToken}`
                const booleanCalledAxios = axios(originalRequest)

                return booleanCalledAxios
            } else {
                alert('인증정보 갱신에 실패했습니다. 다시 로그인 해주세요')
                store.dispatch('LOGOUT')
            }

        } else if (error.response.status === 403) {
            alert('잘못된 인증 요청, 좋지 않은 결과를 드려 죄송합니다. 다시 로그인 해주세요')
            store.dispatch('LOGOUT')
        }
    }
)

export const sync = {
    post: {
        // @Url /v1/auth/excel/sync-upload-file
        syncUpload: async (params) => {
            params['refreshToken'] = `${localStorage.getItem('refreshToken')}`
            params['currentToken'] = `${localStorage.getItem('accessToken')}`
            let formData = objectToFormdata(params)
            return await https.post(
                `/v1/auth/excel/sync-upload-file`, formData
            )
        },
        // @Url /v1/auth/so/staff-workhour-init
        staffWorkHour: async (params) => {
            params['refreshToken'] = `${localStorage.getItem('refreshToken')}`
            params['currentToken'] = `${localStorage.getItem('accessToken')}`
            let formData = objectToFormdata(params)
            return await https.post(
                `/v1/auth/so/staff-workhour-init`, formData
            )
        },
        // @Url /v1/auth/so/sync-calculate-salary 
        syncCalculateSalary: async (params) => {
            params['refreshToken'] = `${localStorage.getItem('refreshToken')}`
            params['currentToken'] = `${localStorage.getItem('accessToken')}`
            let formData = objectToFormdata(params)
            return await https.post(
                `/v1/auth/so/sync-calculate-salary`, formData
            )
        },
        // @Url /v1/auth/so/resync-claim-detail
        reSyncClaimDetail: async (params) => {
            params['refreshToken'] = `${localStorage.getItem('refreshToken')}`
            params['currentToken'] = `${localStorage.getItem('accessToken')}`
            let formData = objectToFormdata(params)
            return await https.post(
                `/v1/auth/so/resync-claim-detail`, formData
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/api/bosync.js